export default {
  biTasksBySiteAndDate: 'BI_TASKS_BY_SITE_AND_DATE',
  biTasksByDate: 'BI_TASKS_BY_DATE',
  biTasksBySite: 'BI_TASKS_BY_SITE',
  biTasksScheduleStatistics: 'BI_TASKS_SCHEDULE_STATISTICS',
  biTasksByEmployee: 'BI_TASKS_BY_EMPLOYEE',
  biTaskLog: 'BI_TASK_LOG',
  setLoadingState: 'BI_TASKS_SET_LOADING_STATE',
};
